import { render, staticRenderFns } from "./SelectSections.vue?vue&type=template&id=c3cc46bc"
import script from "./SelectSections.vue?vue&type=script&lang=js"
export * from "./SelectSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports